import { call, put, all, takeEvery } from 'typed-redux-saga/macro'
import { SagaReturnType } from 'redux-saga/effects'

import { updateUserService } from '../services/user'
import { UPDATE_USER, updateUserSuccess, updateUserFailure } from '../actions/user'
import { getCurrentUserProfileSuccess } from '../actions/app'

import { UpdateUserPayload } from '../types/user'

function* userWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(UPDATE_USER, updateUserWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* updateUserWorker({ userData, userId }: UpdateUserPayload): Generator {
  try {
    const response: SagaReturnType<typeof updateUserService> = yield call(updateUserService, userData, userId)

    yield put(updateUserSuccess(response))
    yield put(getCurrentUserProfileSuccess(response))
  } catch (e: any) {
    yield put(updateUserFailure(e))
  }
}

export default userWatcher
